export const arrowStyles = (value: string | null | undefined) => {
	switch (value) {
		case "up":
			return "h-4 w-4 fill-success-light";
		case "down":
			return "h-4 w-4 fill-error-light";
		case "rev-up":
			return "h-4 w-6 scale-y-[-1] fill-success-light";
		case "rev-down":
			return "h-4 w-6 fill-error-light";
		case null:
		case undefined:
			return "h-4 w-6 opacity-0";
	}
};
